const TZ = "Europe/Rome";

export function formatPrice(priceType, cents) {
  if (priceType === "on_request" || cents == null) return "Su richiesta";
  const v = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  return priceType === "from" ? `da ${v}` : v;
}

export const formatDate = (iso, opts = {}) =>
  new Intl.DateTimeFormat("it-IT", { timeZone: TZ, weekday: "long", day: "numeric", month: "long", year: "numeric", ...opts }).format(new Date(iso));

export const formatTime = (iso) =>
  new Intl.DateTimeFormat("it-IT", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }).format(new Date(iso));

export const formatDateTime = (iso) => `${formatDate(iso, { weekday: "short" })} · ${formatTime(iso)}`;

export function romeDateKey(d = new Date()) {
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
  return p;
}

// Converts a Europe/Rome local date+time ("2026-03-29", "10:30") into an ISO UTC string, DST aware.
export function romeLocalToIso(dateKey, hhmm) {
  const [y, m, d] = dateKey.split("-").map(Number);
  const [h, mi] = hhmm.split(":").map(Number);
  let guess = Date.UTC(y, m - 1, d, h, mi);
  for (let i = 0; i < 2; i++) {
    const parts = new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).formatToParts(new Date(guess));
    const g = Object.fromEntries(parts.map((p) => [p.type, p.value]));
    const shown = Date.UTC(+g.year, +g.month - 1, +g.day, +g.hour, +g.minute);
    guess += Date.UTC(y, m - 1, d, h, mi) - shown;
  }
  return new Date(guess).toISOString();
}

export const addDays = (key, n) => {
  const [y, m, d] = key.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + n));
  return dt.toISOString().slice(0, 10);
};

export const treatmentPath = (t) => `/trattamenti/${t.category_slug || "consulenza"}/${t.slug}`;

export const newIdempotencyKey = () =>
  (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "");
